import React from 'react';
import { Plus } from 'lucide-react';
import useMobileHeaderActions from '../../../hooks/useMobileHeaderActions';

const ReportHeader = ({ onAddReport }) => {
  useMobileHeaderActions(
    <button onClick={onAddReport} className="btn btn-sm btn-primary">
      <Plus size={14} />
      <span>New Report</span>
    </button>,
    [onAddReport]
  );

  return (
    <>
      {/* Desktop Layout */}
      <div className="hidden md:flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Treatment Reports</h1>
          <p className="text-gray-600">
            Manage treatment reports and generate invoices
          </p>
        </div>
        <button
          onClick={onAddReport}
          className="bg-pest-blue hover:bg-blue-600 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors"
        >
          <Plus className="h-4 w-4" />
          New Report
        </button>
      </div>

      {/* Mobile subtitle */}
      <div className="md:hidden mb-2">
        <p className="text-gray-600 text-xs">
          Manage treatment reports and generate invoices
        </p>
      </div>
    </>
  );
};

export default ReportHeader;
